/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostDatasetRowChangesPathParams = NonNullable<operations['postDatasetRowChanges']['parameters']['path']>;

export type PostDatasetRowChangesRequestBody = OperationRequestBodyContent<operations['postDatasetRowChanges']>;

export interface Input extends PostDatasetRowChangesPathParams {
  apiVersion?: string;
  body: PostDatasetRowChangesRequestBody;
}

export async function postDatasetRowChanges(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/datasets/{datasetId}/rows/changes', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
